// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    // Optional
    loadProductFirst: true,
    rangeSliderMoneyFormat: boostPFSAppConfig.shop.money_format,
  },
  selector: {
    products: "#product-loop",
  },
};

var boostPFSTemplate = {
  saleLabelHtml:
    '<div class="sale-item icn">' + boostPFSConfig.label.sale + "</div>",
  soldOutLabelHtml:
    '<div class="so icn">' + boostPFSConfig.label.sold_out + "</div>",
  newLabelHtml: '<div class="new icn">' + boostPFSConfig.label.new + "</div>",
  vendorHtml: "<h4>{{itemVendorLabel}}</h4>",
  quickViewHtml:
    '<a class="fancybox.ajax product-modal" href="{{itemUrl}}?view=quick">' +
    boostPFSConfig.label.quick_view +
    "</a>",

  // Grid Template
  productGridItemHtml:
    '<div id="product-listing-{{itemId}}" class="product-index {{itemGridWidthClass}} tablet-half mobile-half" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}">' +
    '<div class="product-index-inner">' +
    "{{itemNewLabel}}" +
    "{{itemSaleLabel}}" +
    "{{itemSoldoutLabel}}" +
    "</div>" +
    '<div class="prod-image">' +
    '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
    '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
    "</a>" +
    "{{itemQuickView}}" +
    "</div>" +
    '<div class="product-info">' +
    '<div class="product-info-inner">' +
    '<a href="{{itemUrl}}">' +
    "{{itemVendor}}" +
    "<h3>{{itemTitle}}</h3>" +
    "</a>" +
    "{{itemReviews}}" +
    '<div class="price">{{itemPrice}}</div>' +
    "{{itemSwatch}}" +
    "</div>" +
    "</div>" +
    "</div>",

  // Pagination Template
  previousHtml:
    '<a href="{{itemUrl}}" title=""><i class="fa fa-caret-left"></i></a>',
  nextHtml:
    '<a href="{{itemUrl}}" title=""><i class="fa fa-caret-right"></i></a>',
  pageItemHtml: '<a href="{{itemUrl}}" title="">{{itemTitle}}</a>',
  pageItemSelectedHtml: '<span class="current">{{itemTitle}}</span>',
  pageItemRemainHtml: "{{itemTitle}}",
  paginateHtml: "{{previous}}{{pageItems}}{{next}}",
  paginateTopHtml:
    '{{previous}} <span class="pagination-count"></span> {{next}}',

  // Sorting Template
  sortingHtml:
    '<select aria-label="Sort by" class="styled-select">{{sortingItems}}</select>',
};

(function () {
  BoostPFS.inject(this);

  PageInfoCollection.prototype.buildCollectionDetail = function () {
    if (
      typeof this.collectionData !== "undefined" &&
      this.collectionData.hasOwnProperty("collection")
    ) {
      // Get collection info
      var collectionInfo = this.collectionData.collection;
      var title =
        collectionInfo.hasOwnProperty("title") && collectionInfo.title != ""
          ? collectionInfo.title
          : null;
      var description =
        collectionInfo.hasOwnProperty("description") &&
        collectionInfo.description != ""
          ? collectionInfo.description
          : null;
      var image =
        collectionInfo.hasOwnProperty("image") &&
        collectionInfo.image &&
        collectionInfo.image.src
          ? collectionInfo.image.src
          : null;
      // Build Collection Title
      if (title) {
        this.$collectionHeader.html(title).show();
      } else {
        this.$collectionHeader.hide();
      }
      // Build Collection Description
      if (description) {
        console.log(description);
        if (
          jQ(".boost-pfs-filter-collection-description.bottom-description")
            .length > 0
        ) {
          if (description.indexOf("<!-- split -->") > -1) {
            var descriptionArr = description.split("<!-- split -->");
            var shortDescription = descriptionArr[0];
            var longDescription = descriptionArr[1];
            jQ(".boost-pfs-filter-collection-description.top-description")
              .html(shortDescription)
              .show();
            jQ(".boost-pfs-filter-collection-description.bottom-description")
              .html(longDescription)
              .show();
          } else {
            jQ(
              ".boost-pfs-filter-collection-description.top-description"
            ).hide();
            jQ(".boost-pfs-filter-collection-description.bottom-description")
              .html(description)
              .show();
          }
        } else {
          jQ(".boost-pfs-filter-collection-description.top-description").hide();
          jQ(".boost-pfs-filter-collection-description.bottom-description")
            .html(description)
            .show();
        }
      } else {
        jQ(".boost-pfs-filter-collection-description.top-description").hide();
        jQ(
          ".boost-pfs-filter-collection-description.bottom-description"
        ).hide();
      }
      // Build Collection Image
      if (image) {
        this.$collectionImage
          .attr("src", image)
          .css("background-image", "url(" + image + ")")
          .removeClass(Class.collectionNoImage)
          .addClass(Class.collectionHasImage);
      } else {
        this.$collectionImage
          .attr("src", "")
          .css("background-image", "none")
          .removeClass(Class.collectionHasImage)
          .addClass(Class.collectionNoImage);
      }
    }
  };

  ProductGridItem.prototype.compileTemplate = function (
    data,
    index,
    totalProduct
  ) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    if (!totalProduct) totalProduct = this.totalProduct;

    if (
      typeof Globals.moneyFormatWithCurrency !== "undefined" &&
      Globals.moneyFormatWithCurrency.includes("USD")
    ) {
      Globals.moneyFormatWithCurrency = Globals.moneyFormatWithCurrency.replace(
        "USD",
        ""
      );
    }
    
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Add itemGridWidthClass
    var itemGridWidthClass = "";
    var productsPerRow = boostPFSConfig.custom.products_per_row;
    switch (productsPerRow) {
      case 6:
        itemGridWidthClass = buildItemGridClass(
          "desktop-2",
          index,
          productsPerRow
        );
        break;
      case 4:
        itemGridWidthClass = buildItemGridClass(
          "desktop-3",
          index,
          productsPerRow
        );
        break;
      case 3:
        itemGridWidthClass = buildItemGridClass(
          "desktop-4",
          index,
          productsPerRow
        );
        break;
      case 5:
        itemGridWidthClass = buildItemGridClass(
          "desktop-fifth",
          index,
          productsPerRow
        );
        break;
      case 2:
        itemGridWidthClass = buildItemGridClass(
          "desktop-6",
          index,
          productsPerRow
        );
        break;
      default:
        break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add Label
    var itemNewLabelHtml = "";
    var itemSaleLabelHtml = "";
    var itemSoldoutLabelHtml = "";
    if (!soldOut) {
      for (var k in data.collections) {
        if (data["collections"][k]["handle"] == "new") {
          itemNewLabelHtml = boostPFSTemplate.newLabelHtml;
          break;
        }
      }
      if (onSale) {
        itemSaleLabelHtml = boostPFSTemplate.saleLabelHtml.replace(
          /{{itemOldPrice}}/g,
          Utils.formatMoney(data.price_min, Globals.moneyFormat)
        );
      }
    } else {
      itemSoldoutLabelHtml = boostPFSTemplate.soldOutLabelHtml;
    }
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = "";
    if (onSale) {
      itemPriceHtml +=
        '<div class="onsale">' +
        Utils.formatMoney(data.price_min, Globals.moneyFormatWithCurrency) +
        "</div>";
      itemPriceHtml +=
        '<div class="was">' +
        Utils.formatMoney(
          data.compare_at_price_min,
          Globals.moneyFormatWithCurrency
        ) +
        "</div>";
    } else {
      itemPriceHtml += '<div class="prod-price">';
      if (priceVaries) {
        itemPriceHtml +=
          boostPFSConfig.label.from_price +
          " " +
          Utils.formatMoney(data.price_min, Globals.moneyFormatWithCurrency) +
          " - " +
          Utils.formatMoney(data.price_max, Globals.moneyFormatWithCurrency);
      } else {
        itemPriceHtml += Utils.formatMoney(
          data.price_min,
          Globals.moneyFormatWithCurrency
        );
      }
      itemPriceHtml += "</div>";
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);


    // Add itemImages
    var itemImagesHtml = "";
    var itemThumbUrl =
      images.length > 0
        ? Utils.optimizeImage(images[0]["src"], "500x")
        : boostPFSConfig.general.no_image_url;

    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Quick view
    var itemQuickViewHtml = boostPFSConfig.custom.quick_view_enable
      ? boostPFSTemplate.quickViewHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Swatches
    var itemSwatchHtml = "";
    if (boostPFSConfig.custom.alternate_colors) {
      for (var k = 0; k < data.options_with_values.length; k++) {
        var option = data["options_with_values"][k]["name"];
        var option_handle = Utils.slugify(option);
        var option_index = k;

        var is_color = false;
        var downcased_option = option.toLowerCase();
        if (
          downcased_option.indexOf("color") > -1 ||
          downcased_option.indexOf("colour") > -1
        ) {
          // Count the number of color variants
          var colorVariantCount = 0;
          var optionValues = data["options_with_values"][k]["values"];
          for (var i = 0; i < optionValues.length; i++) {
            if (optionValues[i]["title"]) {
              colorVariantCount++;
            }
          }
          if (colorVariantCount > 1) {
            //if(data.variants.length > 1) {
            itemSwatchHtml += '<div class="col-swatch">';
            itemSwatchHtml +=
              '<ul data-option-index="' +
              option_index +
              '" class="' +
              option_handle +
              ' options">';
            var values = "";
            var optionValues = data["options_with_values"][k]["values"];
            for (var i = 0; i < optionValues.length; i++) {
              var value = optionValues[i]["title"];
              var wrapped_value = "," + value + ",";
              if (values.indexOf(wrapped_value) == -1) {
                var variantImage = "";
                if (optionValues[i]["image"] != null) {
                  var imageIndex = optionValues[i]["image"];
                  if (typeof images[imageIndex - 1] !== "undefined") {
                    variantImage = Utils.optimizeImage(
                      images[imageIndex - 1]["src"]
                    );
                  }
                }
                var fileColorUrl = boostPFSConfig.general.asset_url.replace(
                  "boost-pfs.js",
                  Utils.slugify(value) + ".png"
                );
                itemSwatchHtml +=
                  '<li data-option-title="' +
                  value +
                  '" data-href="' +
                  variantImage +
                  '" class="color ' +
                  Utils.slugify(value) +
                  '">';
                itemSwatchHtml +=
                  '<span style="background-color: ' +
                  Utils.slugify(value.split(" ").pop()) +
                  "; background-image: url(" +
                  fileColorUrl +
                  ')"></span>';
                itemSwatchHtml == "</li>";
                values += values + wrapped_value;
              }
            }
            itemSwatchHtml += "</ul>";
            itemSwatchHtml += "</div>";
          }
        }
      }

      itemSwatchHtml +=
        "<script>" +
        "$('#product-listing-{{itemId}} .col-swatch li').each(function(){" +
        "var Original = $('#product-listing-{{itemId}} .prod-image img').attr('data-original'); " +
        "$(this).hover(function() {" +
        "var newImage = $(this).attr('data-href');" +
        "if (newImage){" +
        "$( '#product-listing-{{itemId}} .prod-image img' ).attr({ srcset: newImage }); " +
        "}" +
        "return false;" +
        "}, function(){" +
        "$('#product-listing-{{itemId}} .prod-image img' ).attr({ srcset: Original }); " +
        "});" +
        "});" +
        "</script>";
    }
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      var itemReviewsHtml = boostPFSConfig.custom.show_reviews
        ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'
        : "";
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, data.price_min);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{firstVariantId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    return itemHtml;
  };

  function buildItemGridClass(itemClass, index, productsPerRow) {
    if (index > 0) {
      if (index % productsPerRow == productsPerRow - 1) {
        itemClass += " last";
      } else {
        if (index % productsPerRow == 0) {
          itemClass += " first";
        } else {
          itemClass += "";
        }
      }
      return itemClass;
    } else {
      itemClass += " first";
      return itemClass;
    }
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;

    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage !== 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = currentPage > 1 ? boostPFSTemplate.previousHtml : "";
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextHtml : "";
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return "";
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          sortingItemsHtml +=
            '<option value="' + k + '">' + sortingArr[k] + "</option>";
        }
        var html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {};

  // Build additional elements
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    setTimeout(function () {
      if (
        eventType === "init" &&
        jQ(".boost-pfs-filter-options-wrapper").length === 1
      ) {
        if (
          jQ(".boost-pfs-filter-options-wrapper").children().length === 0 &&
          jQ(".boost-no-filter-fix").length !== 0
        ) {
          jQ(".boost-no-filter-fix").css("width", "100%");
        }
      }
    }, 20);
    // Build Total Products
    if (Settings.getSettingValue("general.paginationType") == "default") {
      var from =
        Globals.queryParams.page == 1
          ? Globals.queryParams.page
          : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
      var to = from + data.products.length - 1;
      jQ("#pagination")
        .find(".count")
        .html(
          boostPFSConfig.label.showing_items +
            " " +
            from +
            "-" +
            to +
            " " +
            boostPFSConfig.label.pagination_of +
            " " +
            data.total_product
        );

      // Build Top Pagination info
      var currentPage = parseInt(Globals.queryParams.page);
      var totalPage = Math.ceil(data.total_product / Globals.queryParams.limit);
      jQ(".boost-pfs-filter-top-pagination")
        .find(".pagination-count")
        .html(
          currentPage +
            " " +
            boostPFSConfig.label.pagination_of +
            " " +
            totalPage +
            " "
        );
    } else {
      jQ("#pagination .count").hide();
      jQ("#pagination .clear").hide();
      jQ(".boost-pfs-filter-top-pagination").hide();
    }
  };

  FilterApi.beforeCall = function(eventType, eventInfo) {
      if (Shopify && Globals) {
          Globals.queryParams.currency = Shopify.currency.active;
          Globals.queryParams.currency_rate = Shopify.currency.rate;
          Globals.queryParams.country = Shopify.country;
          Globals.queryParams.return_all_currency_fields = false;
      }
  }
})();
